const state = {
  brands: {},
  active: {},
  newBrand: {
    name: ''
  }
}

export default state
